import { Component } from 'react'
import { IconSquircle } from '../../generic'
import _ from 'lodash'

interface Category {
  id: string
  icon: string
  color: string
  name: string
}

interface ModalCategorySelectorProps {
  allCategories?: boolean
  data: {
    categories: Category[]
  }
  setFormField: (data: { key: string; value: any }) => void
  goToNextStep?: () => void
}

export default class ModalCategorySelector extends Component<ModalCategorySelectorProps> {
  getAvailableCategories = (): Category[] => {
    const { allCategories, data } = this.props
    if (allCategories) return data.categories
    // @ts-ignore
    return _.filter(data.categories, (category) => {
      return category.name && !category.name.match(/incident/i)
    })
  }

  onSelect(id: string): void {
    const { setFormField, goToNextStep } = this.props
    setFormField({ key: 'category', value: id })
    setFormField({ key: 'item', value: null })
    if (goToNextStep) goToNextStep()
  }

  render(): JSX.Element {
    return (
      <div style={{ margin: '20px 20px' }}>
        <h2 style={{ textAlign: 'center' }}>Choose a Category</h2>
        <div
          style={{ textAlign: 'center', width: '80%', margin: '40px auto 0' }}
          data-cy="category-container"
        >
          {this.getAvailableCategories().map((category) => (
            <IconSquircle
              style={{ width: 110 }}
              key={category.id}
              icon={category.icon}
              color={category.color}
              label={category.name}
              onSelect={() => this.onSelect(category.id)}
            />
          ))}
        </div>
      </div>
    )
  }
}
